import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getCompaniesFn } from "../api/functions";
import { Link } from "react-router-dom";

import Menu from "../components/Menu";

const CompanyList = (props) => {
  const { isSuccess, isLoading, isError, error, data } = useQuery({
    queryKey: ["companies"],
    queryFn: () => getCompaniesFn(),
    staleTime: Infinity,
  });

  if (isLoading) return <>"Loading..."</>;

  if (isError) return "An error has occured: " + error.message;

  if (isSuccess) {
    console.log(data);
    return (
      <>
        <div className="app">
          <Menu />
          <main>
            <div className="backend-screen">
              <div className="container-narrow">
                <h1>Companies</h1>
                <div className="company-list">
                  {data.map((company, i) => (
                    <div className="company-list-item" key={i}>
                      <Link to={`/company/${company._id}`}>{company.name}</Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </main>
        </div>
      </>
    );
  }
};

export default CompanyList;
